import SearchIcon from "../../modules/icons/search";
import "./searchinput.scss"
import {useState} from "react";

interface ISearchInput {
    placeholder: string
}

const SearchInput = ({placeholder}: ISearchInput) => {
    const [searchText, setSearchText] = useState('');
    return (
        <div className="Search-Input">
            <input value={searchText} onChange={(e) => setSearchText(e.target.value)} type="search" name="searchContent"
                   id="searchContent" placeholder={placeholder}/>
            <div className="Search-Input-Button">
                <SearchIcon/>
            </div>
        </div>
    )
}

export default SearchInput